import TourPage from "@/components/TourPage";

export default function MasaiMaraRoad3Day() {
  return (
    <TourPage
      tourId="kenya/masai-mara-road-3-day"
      title="3 Days Masai Mara Road Safari"
      duration="3 Days / 2 Nights"
      price="Contact for price"
      image="/masaimaragreatmigration.png"
      description="Experience a thrilling 3-day road safari to the world-famous Masai Mara National Reserve. Witness the incredible wildlife diversity and spectacular landscapes while enjoying comfortable accommodations and expert guidance."
      itinerary={[
        {
          day: 1,
          title: "Nairobi to Masai Mara",
          description: "Begin your Masai Mara adventure with a scenic drive.",
          activities: [
            "Early morning pickup from your Nairobi hotel",
            "Drive to Masai Mara with scenic views of the Great Rift Valley",
            "Afternoon game drive in the reserve",
            "Evening relaxation at the lodge"
          ],
          accommodation: "Mara Lodge or Similar",
          meals: "Lunch, Dinner"
        },
        {
          day: 2,
          title: "Full Day in Masai Mara",
          description: "Full day exploring the Masai Mara's wildlife.",
          activities: [
            "Early morning game drive",
            "Return to camp for breakfast",
            "Optional visit to a traditional Masai village",
            "Afternoon game drive in different sectors of the reserve"
          ],
          accommodation: "Mara Lodge or Similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 3,
          title: "Masai Mara to Nairobi",
          description: "Final game drive and return to Nairobi.",
          activities: [
            "Early morning game drive",
            "Breakfast at the lodge",
            "Drive back to Nairobi",
            "Drop-off at your hotel or airport"
          ],
          meals: "Breakfast, Lunch"
        }
      ]}
      inclusions={[
        "Transportation in a tour van/Land Cruiser",
        "Game drives as per itinerary",
        "Service of an English-speaking driver guide",
        "All park entrance fees",
        "All meals as specified in the itinerary",
        "Bottled water during game drives",
        "Accommodation in standard rooms"
      ]}
      exclusions={[
        "International flights",
        "Visa fees",
        "Travel insurance",
        "Tips and gratuities",
        "Personal expenditure",
        "Drinks and beverages",
        "Optional activities not mentioned in the itinerary"
      ]}
    />
  );
}
